module.exports = __webpack_public_path__ + "img/AppCode_icon.0c739053.png";